import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Role } from 'app/infrastructure/model/classes/role.class';
import { OpcionCheckeable } from './selects.service';

export interface VariableCircuitoOut {
  codigo: string;
  titulo: string;
  valorDefault: string;
  tipo: string;
  extraInfo: string;
  esOpcional: boolean;
}

export interface VariableCircuitoIn {
  codigo: string;
  valor: string;
}

export interface ResponseConfiguration {
  form: VariableCircuitoOut[];
  roles: Role[];
  adminUser: string;
}

interface RequestInvocacion {
  comando: string;
  formulario: VariableCircuitoIn[];
  userRoles: Role[];
  archivo: string;
}

export interface ResponseInvocacionUsuario {
  msgResult: string;
  infoUsuario: VariableCircuitoIn[];
}

export interface APISXError {
  errorCode: string;
  errorMessage: string;
}

export interface APISXResultData<T> {
  result: T;
  errores: APISXError[];
}

@Injectable()
export class UsuariosService {
  url = 'api/configuracionUsuario';

  constructor(private sxHttp: SxHttpService) { }

  getFormulario(codSistema: string,
    codNegocio: string,
    codComando: string,
    userId?: number): Promise<ResponseConfiguration> {
    let url = `${this.url}/${codSistema}/${codNegocio}/${codComando}`;

    if (userId !== null) {
      url += `/${userId}`;
    }

    return this.sxHttp.get(url)
      .toPromise()
      .then(response => {
        const data = response.json().data;
        const res = {
          form: data.form,
          roles: data.roles,
          adminUser: data.adminUser
        } as ResponseConfiguration;
        return res;
      });
  }
  getCategories(): Promise<any[]> {
    const url = `${this.url}/getorganizations`;
    return this.sxHttp.get(url).toPromise()
      .then(response => {
        return response.json().data
      })
      .catch(this.handleError);
  }
  invocarComando(codSistema: string, codNegocio: string, codComando: string, form: VariableCircuitoIn[], roles: Role[], file?): Promise<APISXResultData<ResponseInvocacionUsuario>> {
    const requestInvocacion: RequestInvocacion = {
      comando: codComando,
      formulario: form,
      userRoles: roles,
      archivo: file
    };
    const url = `${this.url}/${codSistema}/${codNegocio}/${codComando}`;
    return this.sxHttp.post(url, requestInvocacion)
      .toPromise()
      .then(response => response.json().data as APISXResultData<ResponseInvocacionUsuario>);
  }

  getUserList(systemCode: string, businessCode: string): Promise<VariableCircuitoIn[]> {
    const url = `${this.url}/${systemCode}/${businessCode}`;
    return this.sxHttp.get(url)
      .map(response => response.json().data as VariableCircuitoIn[])
      .toPromise();
  }


  downloadTemplate(codSistema: any, codNegocio: any): any {
    let url = `${this.url}/${codSistema}/${codNegocio}/Template`;

   return this.sxHttp.get(url)
      .map(response => response.json().data as any)
      .toPromise();
  }


  exportListToExcel(codSistema: string, codNegocio: string, form: VariableCircuitoIn[]) {
    const url = `${this.url}/${codSistema}/${codNegocio}/ExportToExcel`;

    const requestInvocacion: RequestInvocacion = {
      comando: 'ExportToExcel',
      formulario: form,
      userRoles: undefined,
      archivo: undefined
    };

    return this.sxHttp.post(url, requestInvocacion)
      .map(response => response.json().data as any)
      .toPromise();
  }
  private handleError(error: any): Promise<any> {
    console.error('Ocurrió un error', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/usuarios.service.ts